import type { colors } from '@/constants/colors';
import { createContext } from 'react';

export type Theme = 'light' | 'dark';

export type ThemeContextType = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  colors: (typeof colors)[Theme];
};

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
